import { dateWordShort } from 'helper/helper';
import { Warning } from 'assets/icons';
import MobileListCard from './MobileListCard';
import Tooltip from 'components/tooltips/Tooltips';
import { SECTOR_CONFIG } from '../../../pages/pages/qualification/qualification';

const QualificationMobileCard = ({ item, onEdit }) => {
  const sector = SECTOR_CONFIG[item.type] || SECTOR_CONFIG.other;

  return (
    <MobileListCard
      title={item.name}
      onClick={() => onEdit(item._id)}
      isSelected={isSelected}
      warning={
        !item.idBestt ? (
          <Tooltip text="La mission n'a pas été référencée sur BeSTT" placement="top">
            <Warning wh={17} color="#EF4444" />
          </Tooltip>
        ) : null
      }
      topRightBadge={
        <span className={`inline-flex items-center rounded-md px-2 py-1 text-sm ring-1 ring-inset ${sector.className}`}>
          {sector.label}
        </span>
      }
      date={item.createdAt ? dateWordShort(item.createdAt) : 'N/A'}
      dateLabel="Créé le"
      statusBadge={
        item.isActive === false ? (
          <span className="inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset bg-red-50 text-red-600 ring-red-500/10">
            Désactivé
          </span>
        ) : null
      }
    />
  );
};

export default QualificationMobileCard;
